import React  from "react";

import {
	USER_AUTHORIZE
} from "./userTypes";

import axios from "axios";
import {axiosDelay} from "../../config/config";

import {
	appSetAlert
} from "../app/appActions";
import {
	persistActiveRoleName
}
from "../persist/persistActions";

export function userGetAuthorization() {
	return (dispatch, getState) => {
		const state = getState();

		const config = state.config.data;
		const pages = state.page.pages;
		const activeRoleName = state.persist.activeRoleName;

		setTimeout(function () {

			const apiUrl = config.authentication.api + "User?&db={0}".format(config.authentication.apiSource);

			// Here we pass a date time stamp to ensure the latest config is always loaded
			axios
				.get(apiUrl)
				.then(function (response) {
					// console.log('userActions', response.data);

					const roleFeatures = response.data.roleFeatures;
					if (roleFeatures) {
						for (let feature of roleFeatures) {
							if (feature.options) {
								feature.options = JSON.parse(feature.options);
							}
						}
					}

					// For Project Hub
					const projectUserGroups = response.data.projectUserGroups !== null ? response.data.projectUserGroups : [];

					// TODO: In the future we will set the activeRoleName used in the
					// role selector however for now we will simply determine the first
					// role that is configured and set it to that
					if (!activeRoleName) {
						// Grab the first role
						dispatch(persistActiveRoleName(pages[0].roles[0].name.toLowerCase()));
					} else {
						// Validate
						if (pages[0].roles.map(r => r.name.toLowerCase()).indexOf(activeRoleName.toLowerCase()) < 0) {
							console.log("**WARN** The persisted role '{0}' doesn't exist... defaulting to '{1}'".format(activeRoleName, pages[0].roles[0].name.toLowerCase()));

							// NOTE: When we do this as user based role we will not change
							// on the fly - user will have no access for the page
							dispatch(persistActiveRoleName(pages[0].roles[0].name.toLowerCase()));
						}
					}

					dispatch(userAuthorizationComplete(true, response.data.email, response.data.roleID, roleFeatures, projectUserGroups));

				})
				.catch(function (error) {
					console.log('**ERROR**', error);

					dispatch(appSetAlert('Whoops!', 'Something went seriously wrong. Please try again.', 'error', 10000));

					dispatch(userAuthorizationComplete(false, null,  null, null))
				});

		}, JSON.parse(axiosDelay()));
	}
}

// Store user and kick off Authentication
export function userAuthorizationComplete(authorized, email, role, roleFeatures, projectUserGroups) {
	return {
		type: USER_AUTHORIZE,
		payload: {authorized: authorized, email: email, role: role, roleFeatures: roleFeatures, projectUserGroups: projectUserGroups}
	}
}
